import { Breadcrumbs } from '../../../AbstractElements';
import { Container, Row } from 'reactstrap';
import Basic from './Basic';
import Advanced from './Advance';
import Alert from './Alert';

const SweetAlertsContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Sweet Alert' parent='Bonus Ui' title='Sweet Alert' />
      <Row>
        <Basic />
        <Advanced />
        <Alert />
      </Row>
    </Container>
  );
};

export default SweetAlertsContainer;
